import React from "react";
import {
  ProcessingStatus,
  ProcessingStatusLabels,
} from "@/models/payslips.model";
import { StatusColors } from "@/utils/status-colours";

interface Props {
  status: ProcessingStatus;
}

function ProcessingStatusTag({ status }: Props) {
  const colors = StatusColors[status];

  return (
    <div
      className={`${colors.bg} ${colors.text}
        flex pt-2 pb-2 pl-3 pr-3 rounded-xl font-semibold justify-center items-center w-max text-xs`}
    >
      {ProcessingStatusLabels[status]}
    </div>
  );
}

export default ProcessingStatusTag;
